import {Component, Input, OnInit} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../../../environments/environment';
import * as moment from "moment";

@Component({
  selector: 'tripmakery-housing-info-overview-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.css']
})
export class BookingsComponent implements OnInit {

  constructor(private http: HttpClient) {
  }

  @Input() public housingId;
  public section = 'booking';

  public bookings;
  public paginationData;
  public currentPage = 1;

  ngOnInit() {
    const httpParams = this.createParams();
    this.requestBookingDataFromBackend(httpParams);
  }

  public createParams() {
    let params = new HttpParams();
    params = params.append('page', this.currentPage.toString());
    params = params.append('limit', '15');
    return params;
  }

  public requestBookingDataFromBackend(httpParams) {
    this.http.get(environment.urls.service + '/api/v1/authenticated/admin/housing/' + this.housingId + '/bookings', {params: httpParams})
      .subscribe(
        (response: any) => {

          /* */
          for (const booking of response.elements) {
            booking.created = moment(booking.created).locale("de").format("L")
          }

          /* */
          this.bookings = response.elements;
          this.paginationData = response.pagination;
        }
      );
  }

  public sendPage(page: number) {
    this.currentPage = page;
    const changePageParams = this.createParams();
    this.requestBookingDataFromBackend(changePageParams);
  }
}
